import {useMemo, useState, useEffect, useCallback, useRef, useLayoutEffect} from 'react';
import style from './index.module.less'
import {Switch} from "antd";
import {createPortal} from "react-dom";

type TMenu = {
    label: string
    key: string
    enabled?: boolean
    type?: string
    toggleStatus?: boolean
    nowTableIndex?:number
}

const RightMenu = {

    resole(key?: string) {
        return ''
    },
    open(x: number, y: number, menus: TMenu[],editor:any) {
        return new Promise((resolve) => { })
    },
    Context() {
        const [show, setShow] = useState<boolean>(false)
        const memuRef = useRef(null)
        const boxRef = useRef(null)
        const [list, setList] = useState<TMenu[]>([])
        const [styles, setStyles] = useState<any>({})
        const mEditor = useRef<any>(null);

        useLayoutEffect(() => {
            if (show && memuRef.current) {
                const el = memuRef.current as HTMLElement;
                const rect = el.getBoundingClientRect();
                const vw = window.innerWidth;
                const vh = window.innerHeight;
                const newStyles: any = { ...styles };
                if (rect.bottom > vh) {
                    newStyles.top = Math.max(4, vh - rect.height - 4) + 'px';
                }
                if (rect.right > vw) {
                    newStyles.left = Math.max(4, vw - rect.width - 4) + 'px';
                }
                if (newStyles.top !== styles.top || newStyles.left !== styles.left) {
                    setStyles(newStyles);
                }
            }
        }, [show, list]);

        useEffect(() => {
            RightMenu.open = (x: number, y: number, menus: TMenu[],editor:any) => {
                mEditor.current = editor;
                return new Promise((resolve: any) => {
                    RightMenu.resole = resolve
                    setStyles({
                        left: x+'px',
                        top: y+'px'
                    })
                    setList(menus)
                    setShow(true)
                    // setTimeout(()=>{
                    //     let w = boxRef?.current?.el.offsetWidht
                    //     console.log('w: ', w);
                    // },1)
                })
            }

        }, [])

        function click(item?:TMenu) {
            if(item?.enabled === false) return
            RightMenu.resole(item?.key)
            setShow(false)
            setList([])
        }

        const handleToggleChange = (checked, item,index) => {
            // 在这里处理状态变更逻辑
            const newList = [...list];
            newList[index].toggleStatus = checked;
            setList(newList); // 使用 setList 更新状态

            let currentTableNP=mEditor.current?.$doc.querySelectorAll('table')[newList[index].nowTableIndex]
            if (newList[index].label === 'Header row') {
                // 聚焦到第一行
                let nowRowNP=currentTableNP.querySelectorAll('tableRow')[0]
                mEditor.current?.chain().focus().selectRow(nowRowNP.pos).run();
                mEditor.current?.chain().focus().toggleHeaderRow().run();
                currentTableNP.setAttribute(Object.assign(currentTableNP.attributes,{
                    toggleHeaderRow:checked
                }))
            }
            if (newList[index].label === 'Header column') {
                let nowColNP=currentTableNP.querySelectorAll('tableRow')[0].querySelectorAll('tableCell')[0]
                if(!nowColNP){
                    nowColNP=currentTableNP.querySelectorAll('tableRow')[0].querySelectorAll('tableHeader')[0]
                }
                mEditor.current?.chain().focus().selectColumn(nowColNP.pos-1).run();
                mEditor.current?.chain().focus().toggleHeaderColumn().run();
                currentTableNP.setAttribute(Object.assign(currentTableNP.attributes,{
                    toggleHeaderCell:checked
                }))
            }
        };

        if (!show || !list.length) return null
        return createPortal(
            <div className={style.RightMenu} onClick={() => click()} ref={boxRef}>
                <div className={style.list} onClick={(e) => {
                    e.stopPropagation()
                }} style={styles} ref={memuRef}>
                    {
                        list.map((item, index) => item.type == 'divider'?<div className={'line'} style={{margin:'1px 0'}}></div>:<div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                minHeight: '32px',
                                cursor: 'pointer'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                click(item)
                            }} key={item.key} className={'hovered-blue ' + (item.enabled === false ? style.disbaled : null)}>
                            <div className={'flex-row-vertical-center'}>
                                {
                                    item.icon? item.icon:<></>
                                }
                                <span>{item.label}</span>
                            </div>

                            {item.type === 'toggleBtn' && (
                                <Switch
                                    style={{marginLeft: '2px'}}
                                    checked={item.toggleStatus}
                                    onChange={(checked) => handleToggleChange(checked, item, index)}
                                    onClick={(checked, e) => e.stopPropagation()}
                                />
                            )}
                        </div>)
                    }
                </div>
            </div>
        ,document.body)
    }
}
export default RightMenu